module.exports = __webpack_public_path__ + "img/step_third_white.740c82ab.svg";